module.exports = __webpack_public_path__ + "img/home-decor-2.249f600c.jpg";